// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ea57fc3","239":"ef505180","293":"a1ea51c6","439":"51bc333a","550":"7b23f277","569":"215c6a75","852":"8f1fd225"}[chunkId] + ".chunk.js";
};